export default __webpack_public_path__ + "static/media/21.b7da5f23.jpg";